import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar"]

  connect() {
    this.isCollapsed = false
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed
    console.log("Toggle called, isCollapsed:", this.isCollapsed)
    
    if (this.isCollapsed) {
      this.sidebarTarget.classList.remove("w-64")
      this.sidebarTarget.classList.add("w-16")
      
      // Hide all text elements
      const textElements = this.sidebarTarget.querySelectorAll(".sidebar-text")
      console.log("Found text elements:", textElements.length)
      textElements.forEach(el => el.classList.add("hidden"))
    } else {
      this.sidebarTarget.classList.remove("w-16")
      this.sidebarTarget.classList.add("w-64")
      
      // Show all text elements
      const textElements = this.sidebarTarget.querySelectorAll(".sidebar-text")
      textElements.forEach(el => el.classList.remove("hidden"))
    }
  }
}
